import React from 'react';
import classNames from 'classnames';

import './FaqTag.styles.scss';

type FaqTagProps = {
  className?: string;
};

const FaqTag: React.FC<FaqTagProps> = (props) => {
  const { className } = props;

  const classes = classNames('faq-tag', className);

  return <span className={classes}>FAQ</span>;
};

export default FaqTag;
